import React from 'react'
import { keyframes } from '@emotion/react'

import { useTheme } from '@mui/material/styles'
import { Box } from '@mui/material'

const bounce = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`

const LoadingBubbles = () => {
  const theme = useTheme()

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      {Array.from({ length: 3 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            width: 10,
            height: 10,
            margin: '0 5px',
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            animation: `${bounce} 1s ${0.2 * index}s infinite alternate`,
          }}
        />
      ))}
    </Box>
  )
}

export default LoadingBubbles
